import * as React from "react"
//import { HotTable } from "@handsontable/react"
import HotTable from "react-handsontable"
import EditAccountModal from "./edit-account-modal"
import AddAccountModal from "./add-account-modal"
import AttachAccountModal from "./attach-account-modal"
import * as Model from "../../../../../model"
import { instructionChapterRenderer } from "../../../../utils/handsontable/renderers"
import { NotificationProps } from "../../../../notification"

class InstructionListComponent
extends React.Component<InstructionListComponentProps> {
	render() {
		const editLaca      = this.props.editLaca
		const addAccount    = this.props.addLaca
		const attachAccount = this.props.attachAccount
		return <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
			{ this.props.consulted
			? null
			: <p className="section">
					<span><button className="button is-primary" disabled={this.props.loading} onClick={this.props.onClickAddAccount} type="button">Création d'un compte</button></span>&nbsp;
					<span><button className="button is-link" disabled={this.props.loading} onClick={this.props.onClickAttachAccount} type="button">Attacher un compte existant</button></span>
				</p>
			}
			<HotTable settings={this.getSettings(this.props.lacas, this.props.onClickContextMenu)} />


			{editLaca && (
				<EditAccountModal laca={editLaca}
				classes={this.props.classes}
				chapters={this.props.chapters}
				instruction={this.props.instruction}
				loading={this.props.submitting}
				loadingChapters={this.props.loadingChapters}
				loadingUpdate={this.props.loadingUpdate}
				notification={this.props.notification}
				localAuthority={this.props.localAuthority}
				onClickNotificationCloseButton={e => this.props.onClickNotificationCloseButton(e)}
				onClickCloseButton={this.props.onClickEditAccountModalCloseButton}
				onSubmit={(laca, chapter, account, e) => this.props.onSubmitEditAccountModal(laca, chapter, account, e)} match={undefined} history={undefined} location={undefined}/>
			)}

			{addAccount && (
				<AddAccountModal
				account={null}
				classes={this.props.classes}
				chapters={this.props.chapters}
				instruction={this.props.instruction}
				lacas={this.props.lacas}
				loading={this.props.submitting}
				loadingChapters={this.props.loadingChapters}
				localAuthority={this.props.localAuthority}
				notification={this.props.notification}
				onClickNotificationCloseButton={e => this.props.onClickNotificationCloseButton(e)}
				onClickAddAcountCloseButton={e => this.props.onClickAddAccountModalCloseButton(e)}
				onSubmit={(account, chapter, e) => this.props.onSubmitAddAccountModal(account, chapter, e)} />
			)}

			{attachAccount && (
				<AttachAccountModal
				accounts={this.props.accounts}
				lacas={this.props.lacas}
				chapters={this.props.chapters}
				classes={this.props.classes}
				loading={this.props.submitting}
				loadingChapters={this.props.loadingChapters}
				notification={this.props.notification}
				onClickNotificationCloseButton={e => this.props.onClickNotificationCloseButton(e)}
				onClickAttachAccountModalCloseButton={e => this.props.onClickAttachAccountModalCloseButton(e)}
				onSubmit={(account, chapter, e) => this.props.onSubmitAttachAccountModal(account, chapter, e)} />
			)}
		</div>
	}

	private getSettings(
		lacas: Model.LocalAuthorityChapterAccount[],
		onClickContextMenu: (code: ContextMenuItemCode, laca: Model.LocalAuthorityChapterAccount) => void
	): {} {
		return {
			autoColumnSize: false,
			colHeaders: [
				"Numéro",
				"Libellé",
				"Chapitre",
			],
			columns: this.getColumns(),
			// columnSorting: {
			// 	column: 0,
			// 	sortOrder: "asc"
			// },
			contextMenu: this.props.consulted ? null : this.getContextMenu(onClickContextMenu),
			data: JSON.parse(JSON.stringify(lacas)),
			manualColumnResize: [80, undefined, undefined, undefined, 120],
			minRows: 1,
			readOnly: true,
			stretchH: "all"
		}
	}

	private getColumns(): any[] {
		const presenter = this
		return [
			{
				data: "account.number",
				type: "text",
			},
			{
				data: "account.label",
				type: "text",
			},
			{
				data: "chapter",
				type: "text",
				renderer: instructionChapterRenderer
			},
		]
	}

	private getContextMenu(
		onClickContextMenu: (code: ContextMenuItemCode, laca: Model.LocalAuthorityChapterAccount) => void
	): HotContextMenu {
		return {
			items: {
				[ContextMenuItemCode.EditAccount]: {
					name: "Modifier le compte",
					callback() {
						const selection = this.getSelected()
						const laca = this.getSourceDataAtRow(selection[0]) as Model.LocalAuthorityChapterAccount
						onClickContextMenu(ContextMenuItemCode.EditAccount, laca)
					},
					disabled() {
						const selection = this.getSelected()
						const laca = this.getSourceDataAtRow(selection[0])
						return null === laca.account || !laca.account.id
					}
				}
			}
		}
	}
}

interface HotContextMenu {
	items?: { [key: string]: HotContextMenuItem}
	callback?(key, selection, clickEvent): void
}

interface HotContextMenuItem {
	name?: string
	callback?():void
	disabled?(): boolean
}

export default InstructionListComponent

export enum ContextMenuItemCode {
	EditAccount = "edit_account"
}

export interface InstructionListComponentProps {
	accounts: Model.Account[]
	addLaca: boolean
	attachAccount: boolean
	classes: Model.Class[]
	consulted: boolean
	chapters: Model.Chapter[]
	editLaca: Model.LocalAuthorityChapterAccount
	instruction: Model.Instruction
	lacas: Model.LocalAuthorityChapterAccount[]
	loading: boolean
	loadingChapters: boolean
	loadingUpdate: boolean
	localAuthority: Model.LocalAuthority
	localAuthorities: Model.LocalAuthority[]
	notification?: NotificationProps
	submitting: boolean
	onClickAddAccount(e: React.SyntheticEvent<Element>): void
	onClickAddAccountModalCloseButton(e: React.SyntheticEvent<Element>): void
	onClickAttachAccount(e: React.SyntheticEvent<Element>): void
	onClickAttachAccountModalCloseButton(e: React.SyntheticEvent<Element>): void
	onClickContextMenu(code: ContextMenuItemCode, account: Model.LocalAuthorityChapterAccount): void
	onClickNotificationCloseButton(e: React.SyntheticEvent<Element>): void
	onClickEditAccountModalCloseButton(e: React.SyntheticEvent<Element>): void
	onSubmitAddAccountModal(
		account: Model.Account,
		chapter: Model.Chapter,
		e: React.SyntheticEvent<Element>
	): void
	onSubmitAttachAccountModal(
		account: Model.Account,
		chapter: Model.Chapter,
		e: React.SyntheticEvent<Element>
	): void
	onSubmitEditAccountModal(
		laca: Model.LocalAuthorityChapterAccount,
		chapter: Model.Chapter,
		account: Model.Account,
		e: React.SyntheticEvent<Element>
	): void
}



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/instruction-card/instruction-list/instruction-list-component.tsx